<h2 mat-dialog-title>Change Plan</h2>
<p class="subtitle">{{ data.subTitle }}</p>
<mat-dialog-content>
  <p>
    This action will change the plan for VMAX, to make the changes available for the client, make
    sure to change it in HostBill too.
  </p>
  <form [formGroup]="form">
    <app-input-field
      label="Current plan"
      type="text"
      formControlName="currentPlan"
    ></app-input-field>
    <app-input-field
      label="New plan"
      placeholder="Select plan"
      type="autocomplete"
      formControlName="plan"
      [options]="(displayedPlans$ | async) || []"
      [(searchText)]="planSearchText"
      [errorMessages]="{
        required: 'Plan is required',
        forbidden: 'The selected plan must be different from the current plan',
      }"
    ></app-input-field>
  </form>
</mat-dialog-content>
<mat-dialog-actions>
  <button matButton="filled" (click)="submit()" [disabled]="form.invalid">Save Changes</button>
  <button matButton="elevated" (click)="close()">Close</button>
</mat-dialog-actions>
